import React from "react";
import { Modal } from "react-bootstrap";
import crossIcon from "../../../Assets/images/cross_icon.png";
import styles from "./ConfirmationPop.module.scss";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useGetClientReportPublishHistoryQuery } from "store/services/client";
import { dateFormat } from "helpers/common";

const formatActor = (actor) => {
  if (!actor) return "System";

  const name = [actor.firstname, actor.lastname].filter(Boolean).join(" ");
  return name ? `${name}${actor.role ? ` (${actor.role})` : ""}` : actor.role || "System";
};

const PublishReportHistoryModal = ({ show, setShow, clientId, resourceId }) => {
  const { data, isFetching, isError } = useGetClientReportPublishHistoryQuery(
    { clientId, resourceId },
    { skip: !show || !clientId || !resourceId }
  );

  const records = data?.records || [];
  const handleClose = () => setShow(false);

  return (
    <Modal
      show={show}
      className={`${styles.ConfirmationPop} transparentModal modal-v2`}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      {isFetching && <LoadingOverlay />}
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="section-title d-flex align-items-center justify-content-between" style={{ borderBottom: "1px solid #315D99" }}>
          <h3 className="mb-0 pb-0 section-title border-bottom-0" style={{ fontSize: "14px" }}>
            PUBLISH HISTORY
          </h3>
          <img onClick={handleClose} width={16} height={16} src={crossIcon} alt="Close" style={{ cursor: "pointer" }} />
        </div>

        <div className="mt-2" style={{ overflowX: "auto" }}>
          <table className="w-100">
            <thead>
              <tr>
                {["ACTION", "DATE", "BY", "EMAIL RECIPIENTS"].map((heading) => (
                  <th key={heading} className="fw-medium proxima" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99", whiteSpace: "nowrap" }}>
                    <div className="d-flex ten align-items-center">{heading}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isError ? (
                <tr><td colSpan="6" className="text-center proxima" style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", color: "#000", fontSize: "12px" }}>Unable to load publish history.</td></tr>
              ) : !isFetching && records.length === 0 ? (
                <tr><td colSpan="6" className="text-center proxima" style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", color: "#000", fontSize: "12px" }}>No publish history found.</td></tr>
              ) : records.map((record) => (
                <tr key={record.id}>
                  <td className="proxima text-capitalize" style={cellStyle}>{record.action || "—"}</td>
                  {/* <td className="proxima text-capitalize" style={cellStyle}>{(record.source || "—").replace(/_/g, " ")}</td> */}
                  <td className="proxima" style={cellStyle}>{record.createdAt ? dateFormat(record.createdAt, "MMM DD, YYYY") : "—"}</td>
                  {/* <td className="proxima" style={cellStyle}>{record.panel || "—"}</td> */}
                  <td className="proxima" style={cellStyle}>{formatActor(record.actor)}</td>
                  <td className="proxima" style={cellStyle}>{record.email_recipients?.length ? record?.email_recipients?.map((item) => <ul style={{ margin: 0, padding: 0 }}><li>{item?.email}</li></ul>) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const cellStyle = {
  padding: "15px 10px",
  borderRadius: 0,
  borderBottom: "1px solid #8F8F8F",
  color: "#000",
  fontSize: "12px",
};

export default PublishReportHistoryModal;
